import { format } from "date-fns";
import React from "react";
import { Link } from "react-router-dom";
import { JdsButton } from "../../../components/jds/JdsButton";
import { EyeIcon } from "../../../components/jds/icons";

const subscriptionsMigrationsListColumns = [
  {
    name: "Ação",
    cell: row => (
      <Link target="_self" to={`/subscription_migration/${row.id}`}>
        <JdsButton
          variant="ghost"
          color="neutral"
          size="sm"
          iconOnly
          aria-label="Ver migração"
          title="Ver migração"
        >
          <EyeIcon />
        </JdsButton>
      </Link>
    ),
    width: "70px"
  },
  {
    name: "Cadastrado em",
    selector: row => row.created_at,
    width: "150px",
    cell: row => (
      <div>
        {row.created_at ? format(new Date(row.created_at), "dd/MM/yyyy HH:mm") : "Data indisponível"}
      </div>
    ),
    sortable: true
  },
  {
    name: "Plano atual",
    selector: row => row?.old_plan ? row.old_plan.name : "-",
    maxWidth: "300px",
    sortable: true
  },
  {
    name: "Preço atual",
    selector: row => row?.old_plan ? `R$${row.old_plan.amount}` : "-",
    maxWidth: "120px",
    sortable: true
  },
  {
    name: "Novo plano",
    selector: row => row?.new_plan ? row.new_plan.name : "-",
    maxWidth: "300px",
    sortable: true
  },
  {
    name: "Novo preço",
    selector: row => row?.new_plan ? `R$${row.new_plan.amount}` : "-",
    maxWidth: "120px",
    sortable: true
  },
  {
    name: "Dias para migração",
    selector: row => row.after_days ?? "Não especificado",
    maxWidth: "180px",
    sortable: true
  },
];

export { subscriptionsMigrationsListColumns };
